import { render } from "./SideBanner.vue?vue&type=template&id=737e643b&scoped=true"
import script from "./SideBanner.vue?vue&type=script&lang=js"
export * from "./SideBanner.vue?vue&type=script&lang=js"

import "./SideBanner.vue?vue&type=style&index=0&id=737e643b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737e643b"]])

export default __exports__